import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
//material-ui
import TablePagination from "react-js-pagination";

//useStyle

const Pagination = (props) => {
  const [pages, setPages] = useState([]);

  const {
    customSelectDataShow,
    customSelectData,
    type,
    // server props
    setPage,
    userTotal,
    rowsPerPage,
    activePage,
    actionShow,
    // client props
    size,
    totalData,
    data,
    setData,
    // selector
    setActionPagination,
    actionPagination,
    paginationSubmitButton,
    setActivePage,
    //for enteries select
    actionEnteries,
    setActionEnteries,
    customEnteriesData,
    handleRowsPerPage,
    customeSelectDataEnteriesShow,
    //for filters
    customeFilterData,
    customFilterDataShow,
    actionFilter,
    setActionFilter,
    handleFilterData,
    actionFilterHandle,
  } = props;

  const [clientData, setClientData] = useState();

  const handlePage = (pageNumber) => {
    setPage(pageNumber);
  };

  const totalPages = Math.ceil(userTotal / rowsPerPage);

  return (
    <>
      <div className=" row gx-0 custom-pagination m-0 w-100 px-3">
        <>
          <div
            className="col-12 pagination d-flex flex-row justify-content-between mt-3 mb-3 "
            style={{ marginRight: "10px" }}
          >
            {type === "server" && (
              <>
                <div
                  className="d-flex justify-content-between pagination-select"
                  style={{ minWidth: "340px" }}
                >
                  {customeSelectDataEnteriesShow && (
                    <FormControl>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{
                          fontWeight: "500",
                          fontSize: "17px",
                          marginBottom: "10px",
                        }}
                      >
                        Enteries
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionEnteries}
                        label="Action"
                        onChange={(e) => {
                          setActionEnteries(e.target.value);
                          handleRowsPerPage(Number(e.target.value));
                        }}
                      >
                        {customeSelectDataEnteriesShow
                          ? customEnteriesData?.map((item) => {
                              return (
                                <MenuItem
                                  value={item?.toLowerCase()}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              );
                            })
                          : ""}
                      </Select>
                    </FormControl>
                  )}
                  {customFilterDataShow && (
                    <FormControl>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{
                          fontWeight: "500",
                          fontSize: "17px",
                          marginBottom: "10px",
                        }}
                      >
                        Filter
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={actionFilter}
                        label="Filter"
                        onChange={(e) => {
                          setActionFilter(e.target.value);
                          actionFilterHandle(e.target.value);
                        }}
                      >
                        {customFilterDataShow
                          ? customeFilterData?.map((item) => {
                              return (
                                <MenuItem value={item} key={item}>
                                  {item}
                                </MenuItem>
                              );
                            })
                          : ""}
                      </Select>
                    </FormControl>
                  )}
                </div>
                {userTotal > rowsPerPage && (
                  <div>
                    <p
                      style={{
                        marginBottom: "0px",
                        color: "1F1F1F",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      Showing {activePage} out of {totalPages} pages
                    </p>
                    <TablePagination
                      activePage={activePage}
                      itemsCountPerPage={rowsPerPage}
                      totalItemsCount={userTotal}
                      pageRangeDisplayed={3}
                      onChange={(page) => handlePage(page)}
                      itemClass="page-item"
                    />
                  </div>
                )}
              </>
            )}

            {type === "client" && userTotal > rowsPerPage && (
              <>
                <p
                  style={{
                    marginBottom: "0px",
                    color: "1F1F1F",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  Showing {activePage} out of {totalPages} pages
                </p>
                <TablePagination
                  activePage={activePage}
                  itemsCountPerPage={rowsPerPage}
                  totalItemsCount={userTotal}
                  pageRangeDisplayed={3}
                  onChange={handlePage}
                  itemClass="page-item"
                />
              </>
            )}
          </div>
        </>
      </div>
    </>
  );
};
export default Pagination;
